import React from 'react';
import TableRow from './TableRow';
import { useLanguage } from '../i18n';

/**
 * 预览表格组件
 * @param {Object} props
 * @param {RenderNode} props.tree - 渲染树
 * @param {Function} props.onToggle - 展开/折叠回调
 */
function PreviewTable({ tree, onToggle }) {
  const { language } = useLanguage();

  return (
    <div className="h-full overflow-auto bg-gradient-to-br from-gray-50 to-white dark:from-gray-800 dark:to-gray-900" style={{ overscrollBehavior: 'contain' }}>
      {/* 表头 */}
      <div className="sticky top-0 bg-gradient-to-r from-indigo-50 to-blue-50 dark:from-indigo-900/50 dark:to-blue-900/50 border-b-2 border-indigo-200 dark:border-indigo-700 z-10 shadow-sm">
        <div className="flex font-bold text-sm">
          <div className="w-1/2 px-6 py-4 border-r-2 border-indigo-200 dark:border-indigo-700 text-indigo-800 dark:text-indigo-200">Key</div>
          <div className="w-1/2 px-6 py-4 text-indigo-800 dark:text-indigo-200">Value</div>
        </div>
      </div>

      {/* 表格内容 */}
      {tree ? (
        <TableRow node={tree} onToggle={onToggle} />
      ) : (
        <div className="flex flex-col items-center justify-center h-64 text-gray-400 dark:text-gray-500">
          <div className="text-6xl mb-4">📝</div>
          <div className="text-lg font-medium">
            {language === 'zh' ? '在左侧输入 JSON 数据以查看预览' : 'Enter JSON on the left to preview'}
          </div>
        </div>
      )}
    </div>
  );
}

export default PreviewTable;
